import { render, staticRenderFns } from "./HomeFeatures.vue?vue&type=template&id=2edd97e2&scoped=true"
import script from "./HomeFeatures.vue?vue&type=script&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&lang=js"
import style0 from "./HomeFeatures.vue?vue&type=style&index=0&id=2edd97e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd97e2",
  null
  
)

export default component.exports